module.exports = __webpack_public_path__ + "fonts/helveticaneue-webfont.7232721f.woff";